'use client'

import { BookOpenText } from "lucide-react"
import { formatDateNormal, formatImageURL } from "@/utils/util"
import { getExcerpt } from "@/utils/blog"
import { navigateUrl } from "@/utils/client-request"
import { usePathname } from "next/navigation"
import EmptyState from "../elements/EmptyState"
import BlogCard from "./BlogCard"

export default function BlogList({ blogs }: { blogs: any[], vendor?: any }) {
  const pathname = usePathname()
  const sorted = [...(blogs || [])].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())

  if (!sorted.length) {
    return (
      <div className="w-full px-4 lg:px-6 py-16">
        <h1 className="sr-only">Нийтлэл</h1>
        <BlogNotFound />
      </div>
    )
  }

  const hero = sorted[0]
  const heroHref = navigateUrl(`/blog/${hero.id}`, pathname)
  const excerpt = getExcerpt(hero.content, 220)

  return (
    <div className="w-full pb-16">
      <h1 className="sr-only">Нийтлэл</h1>

      <section className="lg:grid lg:grid-cols-2">
        <a href={heroHref} aria-hidden tabIndex={-1} className="block aspect-13/8 bg-muted overflow-hidden">
          <img src={formatImageURL(hero.thumbnail || 'placeholder.png')} alt="" className="w-full h-full object-cover transition-opacity duration-300 hover:opacity-90" />
        </a>
        <div className="flex flex-col px-4 lg:px-12 pt-8 pb-12 lg:py-14">
          <h2 className="text-2xl sm:text-4xl leading-tight tracking-tight text-foreground">
            <a href={heroHref} className="focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground">{hero.title}</a>
          </h2>
          <time className="mt-4 block text-sm text-muted-foreground tabular-nums">{formatDateNormal(new Date(hero.createdAt))}</time>
          {excerpt && <p className="mt-4 max-w-xl text-base leading-relaxed text-foreground/80 line-clamp-4">{excerpt}</p>}
          <div className="mt-8 lg:mt-auto">
            <a href={heroHref} className="text-[13px] pb-0.5 bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-position-[0_100%] bg-size-[100%_1px] hover:bg-size-[0%_1px] transition-[background-size] duration-500 ease-out motion-reduce:transition-none focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground">Цааш үзэх</a>
          </div>
        </div>
      </section>

      <section className="pt-12 lg:pt-20">
        <h2 className="px-4 lg:px-6 mb-8 lg:mb-10 text-2xl sm:text-4xl tracking-tight text-foreground">Сүүлд нэмэгдсэн</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-1">
          {sorted.map(blog => <BlogCard key={blog.id} blog={blog} />)}
        </div>
      </section>
    </div>
  )
}

export function BlogNotFound() {
  return <EmptyState icon={BookOpenText} title="Нийтлэл олдсонгүй" description="Яг одоогоор ямар нэгэн нийтлэл байхгүй байна. Хэсэг хугацааны дараа дахин шалгана уу." />
}
